import {APP_BASE_HREF} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbDatepickerI18n, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ModaleImportComponent} from './pages/gestion/moyens/modales/modaleImport/modale-import.component';
import {ModaleAjoutMoyenComponent} from './pages/gestion/moyens/modales/modaleAjoutMoyen/modale-ajout-moyen.component';

import {ModaleEditionProfilComponent} from './pages/gestion/profil/modales/modaleEditionProfil/modale-edition-profil.component';
import {
    NbActionsModule,
    NbDatepickerModule,
    NbGlobalLogicalPosition,
    NbIconModule,
    NbLayoutModule,
    NbMenuModule,
    NbSidebarModule, NbSpinnerModule,
    NbTabsetModule,
    NbThemeModule,
    NbToastrModule, NbToggleModule,
} from '@nebular/theme';
import {ModaleConfirmationComponent} from './pages/modale/modale-confirmation.component';
import {ModaleReportComponent} from './pages/operation/modals/modaleReport/modale-report.component';
import {AtelierRendererComponent} from './pages/operation/atelierRenderer/atelier-renderer.component';
import {AgGridModule} from 'ag-grid-angular';
import {SharedModule} from './shared/shared.module';
import {ModaleEditionUserComponent} from './pages/gestion/utilisateur/modales/modaleEditionUser/modale-edition-user.component';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {FormsModule} from '@angular/forms';
import {TreeviewComponent} from './@theme/components/treeview/treeview.component';
import {JwtTokenInterceptor} from './@core/interceptors/jwt.interceptor';
import {ErrorInterceptor} from './@core/interceptors/error.interceptor';
import 'ag-grid-enterprise';
import {environment} from '../environments/environment';
import { ModuleRegistry } from 'ag-grid-community';
import {EnterpriseCoreModule, LicenseManager } from 'ag-grid-enterprise';
import {CustomDatepickerI18n} from './@core/services/custom-datepicker-i18n';
import {SwitchButtonComponent} from './pages/operation/switch-button/switch-button.component';

@NgModule({
  declarations: [
    AppComponent,
    ModaleImportComponent,
    ModaleAjoutMoyenComponent,
    ModaleEditionProfilComponent,
    ModaleConfirmationComponent,
    ModaleReportComponent,
    AtelierRendererComponent,
    ModaleEditionUserComponent,
    TreeviewComponent,
  ],
  imports: [
    NbEvaIconsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    NbDatepickerModule.forRoot(),
    NbToastrModule.forRoot({
      position: NbGlobalLogicalPosition.BOTTOM_END,
      hasIcon: false,
      destroyByClick: true,
    }),
    AgGridModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbMenuModule.forRoot(),
    SharedModule,
    NbThemeModule.forRoot({name: 'corporate'}),
    NbLayoutModule,
    FormsModule,
    NbTabsetModule,
    NbIconModule,
    NbActionsModule,
    NbSidebarModule,
    NbSpinnerModule,
    NbToggleModule,
    SwitchButtonComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDatepickerI18n,
    },
  ],
})
export class AppModule {
  constructor() {
    ModuleRegistry.registerModules([EnterpriseCoreModule]);
    LicenseManager.setLicenseKey(environment.agGridLicenceKey);
  }
}
